import { Stack, Typography } from "@mui/material";
import noop from "lodash/noop";
import type { FC } from "react";
import { AssociatedFilesView } from "../components/associatedFiles/AssociatedFilesView";
import EntityCard from "../components/entityCard/EntityCard";
import type { UserRole } from "../auth/auth";
import OfferCardProducts from "./OfferCardProducts";
import type { ECommerceOfferWithNames } from "./eCommerceTypes";
import { type ECommerceOfferProductWithNames } from "./eCommerceTypes";

const OfferName: FC<{ name: string; id?: number }> = ({ name, id }) => {
  const value = id ? `${id}: ${name}` : name;
  return <Typography variant="h5">{value}</Typography>;
};

type ECommerceOffer = Pick<ECommerceOfferWithNames, "id" | "name" | "info" | "files"> & {
  readonly products: Pick<ECommerceOfferProductWithNames, "name" | "date" | "providerName" | "options">[];
};

interface Props {
  readonly value: ECommerceOffer;
  readonly role: UserRole | undefined;
  readonly onClick: () => void;
  readonly onContextMenu: () => void;
}

const ECommerceOfferCard: FC<Props> = ({ value, role, onClick, onContextMenu }) => {
  const isAdminOrAgent = role === "ADMIN" || role === "AGENT";
  return (
    <EntityCard role={role} onClick={onClick} onContextMenu={isAdminOrAgent ? onContextMenu : noop}>
      <Stack spacing={1}>
        <OfferName name={value.name} id={value.id.userFriendly} />
        <Typography variant="body2">{value.info}</Typography>
        <OfferCardProducts products={value.products} />
        <AssociatedFilesView values={value.files} />
      </Stack>
    </EntityCard>
  );
};

export default ECommerceOfferCard;
